module.exports = require("mdi-react/ChevronDownIcon");